import React, { useState, useEffect } from 'react';
import { 
  getFavorites, 
  addFavorite, 
  removeFavorite, 
  isFavorite, 
  getCustomSites, 
  addCustomSite, 
  updateCustomSite, 
  deleteCustomSite,
  getFavoritesList
} from '../utils/storage';
import { sitesData, getInterestingCategories } from '../data/InterestingData';

function Interesting() {
  var [sites, setSites] = useState([]);
  var [favorites, setFavorites] = useState([]);
  var [customSites, setCustomSites] = useState([]);
  var [activeCategory, setActiveCategory] = useState('视频平台');
  var [showAddForm, setShowAddForm] = useState(false);
  var [editingSite, setEditingSite] = useState(null);
  var [formData, setFormData] = useState({
    name: '',
    category: '自定义',
    icon: '🌐',
    url: '',
    description: '',
    color: '#6366f1'
  });

  useEffect(function() {
    setSites(sitesData);
    setFavorites(getFavorites());
    setCustomSites(getCustomSites());
  }, []);

  var categories = getInterestingCategories();
  // 添加自定义分类和收藏分类
  var allCategories = ['我的收藏', ...categories, '自定义'];

  var filteredSites = [];
  if (activeCategory === '我的收藏') {
    filteredSites = getFavoritesList(sites);
  } else if (activeCategory === '自定义') {
    filteredSites = customSites;
  } else {
    filteredSites = sites.filter(function(item) {
      return item.category === activeCategory;
    });
  }

  function toggleFavorite(site) {
    var id = String(site.id);
    if (isFavorite(id)) {
      removeFavorite(id);
    } else {
      addFavorite(site);
    }
    setFavorites(getFavorites());
  }

  function handleExternalLinkClick(url) {
    window.open(url, '_blank');
  }

  function handleFormChange(e) {
    var { name, value } = e.target;
    setFormData(function(prev) {
      return { ...prev, [name]: value };
    });
  }

  function handleFormSubmit(e) {
    e.preventDefault();
    if (!formData.name || !formData.url) {
      alert('请填写网站名称和网址');
      return;
    }

    if (editingSite) {
      // 编辑模式
      updateCustomSite(editingSite.id, formData);
    } else {
      // 添加模式
      addCustomSite(formData);
    }

    setCustomSites(getCustomSites());
    resetForm();
  }

  function resetForm() {
    setFormData({
      name: '',
      category: '自定义',
      icon: '🌐',
      url: '',
      description: '',
      color: '#6366f1'
    });
    setShowAddForm(false);
    setEditingSite(null);
  }

  function handleEditSite(site) {
    setEditingSite(site);
    setFormData({
      name: site.name,
      category: site.category || '自定义',
      icon: site.icon || '🌐',
      url: site.url,
      description: site.description || '',
      color: site.color || '#6366f1'
    });
    setShowAddForm(true);
  }

  function handleDeleteSite(siteId) {
    // eslint-disable-next-line no-restricted-globals
    if (window.confirm('确定要删除这个网站吗？')) {
      deleteCustomSite(siteId);
      setCustomSites(getCustomSites());
    }
  }

  var iconOptions = ['🌐', '🎬', '📺', '🎵', '💡', '📚', '🔗', '⭐', '🔥', '✨'];
  var colorOptions = ['#6366f1', '#ec4899', '#8b5cf6', '#06b6d4', '#10b981', '#f59e0b', '#ef4444', '#3b82f6'];

  return (
    <div className="interesting-page">
      {/* 页面头部 */}
      <div className="interesting-header">
        <div className="header-content">
          <div className="header-icon">🎬</div>
          <h1>有趣的网站</h1>
          <p>在这里收藏和浏览您喜爱的视频娱乐网站</p>
        </div>
        <div className="header-actions">
          <button 
            className="add-site-btn"
            onClick={function() { setShowAddForm(true); }}
          >
            ➕ 添加网站
          </button>
        </div>
        <div className="header-decoration"></div>
      </div>

      {/* 添加/编辑表单 */}
      {showAddForm && (
        <div className="add-form-overlay" onClick={function() { resetForm(); }}>
          <div className="add-form-container" onClick={function(e) { e.stopPropagation(); }}>
            <div className="form-header">
              <h3>{editingSite ? '编辑网站' : '添加自定义网站'}</h3>
              <button className="close-btn" onClick={resetForm}>✕</button>
            </div>
            <form className="add-site-form" onSubmit={handleFormSubmit}>
              <div className="form-group">
                <label>网站名称</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  placeholder="例如：我的个人网站"
                  required
                />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>图标</label>
                  <div className="icon-picker">
                    {iconOptions.map(function(icon) {
                      return (
                        <button
                          key={icon}
                          type="button"
                          className={formData.icon === icon ? 'selected' : ''}
                          onClick={function() { setFormData(function(prev) { return { ...prev, icon: icon }; }); }}
                        >
                          {icon}
                        </button>
                      );
                    })}
                  </div>
                </div>
                
                <div className="form-group">
                  <label>颜色</label>
                  <div className="color-picker">
                    {colorOptions.map(function(color) {
                      return (
                        <button
                          key={color}
                          type="button"
                          className={formData.color === color ? 'selected' : ''}
                          style={{ backgroundColor: color }}
                          onClick={function() { setFormData(function(prev) { return { ...prev, color: color }; }); }}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>网址</label>
                <input
                  type="url"
                  name="url"
                  value={formData.url}
                  onChange={handleFormChange}
                  placeholder="https://example.com"
                  required
                />
              </div>

              <div className="form-group">
                <label>描述</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  placeholder="简单描述一下这个网站"
                  rows={3}
                />
              </div>

              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={resetForm}>
                  取消
                </button>
                <button type="submit" className="save-btn">
                  {editingSite ? '保存修改' : '添加网站'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* 分类标签 */}
      <div className="interesting-categories">
        {allCategories.map(function(category) {
          return (
            <button
              key={category}
              className={'category-btn ' + (activeCategory === category ? 'active' : '')}
              onClick={function() { setActiveCategory(category); }}
            >
              {category === '我的收藏' ? '⭐ ' : ''}
              {category === '自定义' ? '➕ ' : ''}
              {category}
            </button>
          );
        })}
      </div>

      {/* 网站网格 */}
      <div className="interesting-grid">
        {filteredSites.length > 0 ? (
          filteredSites.map(function(site) {
            var favorited = isFavorite(String(site.id));
            return (
              <div
                key={site.id}
                className="interesting-card"
                style={{ '--accent-color': site.color }}
              >
                <div className="card-header">
                  <button
                    className={'favorite-toggle ' + (favorited ? 'favorited' : '')}
                    onClick={function(e) { e.stopPropagation(); toggleFavorite(site); }}
                    title={favorited ? '取消收藏' : '添加收藏'}
                  >
                    {favorited ? '❤️' : '🤍'}
                  </button>
                  {site.isCustom && (
                    <div className="custom-actions">
                      <button
                        className="edit-btn"
                        onClick={function(e) { e.stopPropagation(); handleEditSite(site); }}
                        title="编辑"
                      >
                        ✏️
                      </button>
                      <button
                        className="delete-btn"
                        onClick={function(e) { e.stopPropagation(); handleDeleteSite(site.id); }}
                        title="删除"
                      >
                        🗑️
                      </button>
                    </div>
                  )}
                </div>

                {site.cover ? (
                  <div className="card-cover" onClick={function() { handleExternalLinkClick(site.url); }}>
                    <img src={site.cover} alt={site.name} className="cover-image" />
                  </div>
                ) : (
                  <div className="card-icon" onClick={function() { handleExternalLinkClick(site.url); }}>
                    {site.icon}
                  </div>
                )}

                <div className="card-info">
                  <h3 className="card-title" onClick={function() { handleExternalLinkClick(site.url); }}>
                    {site.name}
                  </h3>
                  <p className="card-desc">{site.description}</p>
                </div>

                <button
                  className="visit-btn"
                  onClick={function() { handleExternalLinkClick(site.url); }}
                >
                  访问 →
                </button>
              </div>
            );
          })
        ) : (
          <div className="empty-state">
            <div className="empty-icon">📭</div>
            <h3>暂无网站</h3>
            <p>
              {activeCategory === '我的收藏' 
                ? '快去收藏一些你喜欢的网站吧！' 
                : activeCategory === '自定义' 
                  ? '点击上方添加按钮创建你自己的网站！'
                  : '这个分类下还没有网站'}
            </p>
          </div>
        )}
      </div>

      {/* 特色推荐 */}
      <div className="featured-section">
        <h2 className="section-title">✨ 精选推荐</h2>
        <div className="featured-grid">
          <div className="featured-card douyin-card" onClick={function() { handleExternalLinkClick('https://www.douyin.com/'); }}>
            <div className="featured-icon">🎵</div>
            <div className="featured-content">
              <h3>抖音</h3>
              <p>记录美好生活，发现精彩瞬间</p>
            </div>
          </div>

          <div className="featured-card bilibili-card" onClick={function() { handleExternalLinkClick('https://www.bilibili.com/'); }}>
            <div className="featured-icon">📺</div>
            <div className="featured-content">
              <h3>Bilibili</h3>
              <p>年轻人喜爱的文化社区，二次元聚集地</p>
            </div>
          </div>

          <div className="featured-card youku-card" onClick={function() { handleExternalLinkClick('https://www.youku.com/'); }}>
            <div className="featured-icon">🎬</div>
            <div className="featured-content">
              <h3>优酷视频</h3>
              <p>海量影视内容，精彩不容错过</p>
            </div>
          </div>
        </div>
      </div>

      {/* 页面底部 */}
      <div className="interesting-footer">
        <p>💡 提示：点击网站卡片即可访问，点击心形图标收藏喜欢的网站</p>
      </div>
    </div>
  );
}

export default Interesting;
